import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/storeManager/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
